import { get } from 'lodash'
import * as React from 'react'
import { connect } from 'react-redux'

import * as commonActions from 'common/actions'
import { isFixedSizeEmbed, LoanOfferListItem } from 'embed/constants'
import { SpecialOffer } from 'embed/constants/models'

import LoadingIndicator from 'embed/components/LoadingIndicator'
import { loadingSelector } from 'embed/selectors/loading'
import { OfferType, Product, RedirectType, SortDirection, SpecialOfferSortOption } from 'even-ts-static'
import SpecialOfferList from './index'

export interface Props {
  listItem?: LoanOfferListItem<SpecialOffer>
  dispatchRedirectToOffer?: (offer: SpecialOffer) => null
  dispatchSortChanged?: (sortOption: SpecialOfferSortOption, sortDirection: SortDirection) => null
  isResultsView?: boolean
  limit?: number
  loading: boolean
  product: Product
  rateTableUuid?: string
  sortDirection?: SortDirection
  sortOption?: SpecialOfferSortOption
  specialOffers: SpecialOffer[]
}

const SpecialOfferListContainer = class extends React.Component<Props> {
  static defaultProps: Props = {
    limit: 8,
    listItem: undefined,
    loading: false,
    product: Product.Loan,
    specialOffers: [],
  }

  public render() {
    const { dispatchRedirectToOffer, limit, loading, specialOffers, sortOption, sortDirection, ...other } = this.props

    return loading ? (
      <LoadingIndicator loadingLabel="Finding Loan Offers" showPendingOriginators={true} product={Product.Loan} />
    ) : (
      <SpecialOfferList
        bestOfferId={get(specialOffers[0], 'uuid')}
        dispatchSpecialOfferCta={dispatchRedirectToOffer}
        onSortOptionClick={this.onSortOptionClick}
        sortDirection={sortDirection}
        specialOffers={specialOffers.slice(0, limit)}
        sort={sortOption}
        {...other}
      />
    )
  }

  private readonly onSortOptionClick = (updatedSortOption: SpecialOfferSortOption) => {
    const { dispatchSortChanged, specialOffers, sortOption, sortDirection } = this.props

    if (updatedSortOption === sortOption) {
      // If they clicked the same sort, reverse it
      const updatedSortDirection = sortDirection === SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc
      dispatchSortChanged?.(updatedSortOption, updatedSortDirection)
    } else {
      dispatchSortChanged?.(updatedSortOption, SortDirection.Asc)
    }
  }
}

const mapStateToProps = (state, ownProps) => ({
  loading: loadingSelector(state, Product.Loan),
  rateTableUuid: get(state, `rates.${ownProps.product}.uuid`),
  sortDirection: get(state, `rates.sortDirection.${Product.Loan}`),
  sortOption: get(state, `rates.sortOption.${Product.Loan}`),
  specialOffers: ownProps.specialOffers || get(state, `rates.sorted.${Product.Loan}.specialOffers`),
})

const mapDispatchToProps = (dispatch) => ({
  dispatchRedirectToOffer: (offer: SpecialOffer) =>
    dispatch(
      commonActions.redirectToOffer(offer, OfferType.Special, RedirectType.MANUAL, {
        openInNewTab: isFixedSizeEmbed(),
      }),
    ),
  dispatchSortChanged: (sortOption, sortDirection) =>
    dispatch(commonActions.sortChanged(sortDirection, Product.Loan, sortOption)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SpecialOfferListContainer)
